import script from "./WritingBoardTool.vue?vue&type=script&lang=ts&setup=true"
export * from "./WritingBoardTool.vue?vue&type=script&lang=ts&setup=true"

import "./WritingBoardTool.vue?vue&type=style&index=0&id=92cd0b5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92cd0b5a"]])

export default __exports__